import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/$id/edge-gateways/")({
  staticData: {
    title: "projects.edgeGateways.title",
  },
});
